var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H20V20H17V19ZM22 14.5V22L15 22V14.5L17 14.5V14H20V14.5H22ZM21 15.5H20V16H17V15.5H16V21H21V15.5ZM12.3055 14.9445L12.6389 11.1111V8H11.3611V11.1111L11.6945 14.9445H12.3055ZM12 18C12.4861 18 12.8889 17.5973 12.8889 17.1111C12.8889 16.625 12.4861 16.2222 12 16.2222C11.4999 16.2222 11.1111 16.6111 11.1111 17.1111C11.1111 17.6112 11.4999 18 12 18ZM12 4.03314L16.9589 13H18.1017L12 1.96686L2.0271 20H14V19H3.7229L12 4.03314ZM17 18L20 17.9999V16.9999L17 17V18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertList);
export default __webpack_public_path__ + "static/media/alert-list.b029cf25ccf2505f899b26ae5ec1ee7a.svg";
export { ForwardRef as ReactComponent };